import { useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import { assertNotUndefined } from "utils/hx/util/types";
import { useAppService } from "../../use-app-service";
import { storefrontKeys } from "../query-keys";

export const useGetStorefrontConfigsQuery = () => {
  const service = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());
  return useQuery({
    queryKey: [storefrontKeys.configs(organisationId)],
    queryFn: () => service.orgGetStoreConfigs(organisationId),
  });
};
